import React, { useEffect, useRef } from 'react';

import { fetchLeave, useFormDataQuery, usePresentQuery } from '@/api/getters';
import { Stages } from '@/api/types';
import CustomToast from '@/components/ui/Toast';
import { PRODUCT } from '@/consts';
import AcceptedButNotProcessed from '@/features/v2/summaryForms/components/offer/AcceptedButNotProcessed';
import Offers from '@/features/v2/summaryForms/components/offer/Offers';
import OldOfferPage from '@/features/v2/summaryForms/components/offer/OldOfferPage';

import RejectedOfferCard from './RejectedOfferCard';
import { useLingui } from '@lingui/react';
import { useParams } from 'react-router-dom';

const OfferPage = () => {
  const { data } = useFormDataQuery();
  const { i18n } = useLingui();
  const { id } = useParams();
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const isRejected = data?.offer.offer_rejected;

  const isAcceptedButNotProcessed =
    data?.stage === Stages.STAGE_III_CONFLICT ||
    (data?.product.id === PRODUCT.HOUSE_HOLD &&
      data.stage === Stages.OFFER_FINISHED);

  usePresentQuery(id as string, !isRejected && !isAcceptedButNotProcessed);

  const onVisibilityChange = async () => {
    if (document.visibilityState === 'hidden') {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(async () => {
        if (id) {
          await fetchLeave(id);
        }
      }, 1500);
    }
  };

  useEffect(() => {
    window.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      window.removeEventListener('visibilitychange', onVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) return null;

  if (isAcceptedButNotProcessed) {
    return <AcceptedButNotProcessed isHouseHold />;
  }

  if (isRejected) {
    return <RejectedOfferCard isHouseHold />;
  }

  if (data.offer.with_old_offer) {
    return <OldOfferPage />;
  }
  return (
    <>
      <Offers />
      <CustomToast
        title={`${i18n.t('Pobieranie oferty nie powiodło się.')}`}
        withPhone={true}
      />
    </>
  );
};

export default OfferPage;
